
$(function(){

    //Список городов
    var cities = [];

    //Показываем список городов при клике
    $(document).on("click", "[data-showpop='.js-pop-city-select']", function() {
        //прервать таймер для записи  куки
        if(window.cityInterval != undefined){
            clearInterval(window.cityInterval);
            delete window.cityInterval;
            cityCookie.remove();
            $(".noCityAcceptedCookie").removeClass("noCityAcceptedCookie");
        }
        //Если уже список есть
        if ($(".js-pop-city-select .loader").length == 0) return;

        //Получаем список городов
        $.ajax({
            url: "/ajax/",
            type: "POST",
            data: {action: "get_cities_list"},
            //async: false,
            success: function(response) {

                $(".js-pop-city-select .loader").remove()

                //Создаем список для поиска города
                $.each(response, function(indx, city) {
                    cities.push({
                        label: city.FULL_NAME,
                        city:  city.NAME,
                        id:    city.ID
                    })
                });

                var letters = [],
                    prevSort = -1000;

                //Список городов до алфавита
                var $citiesList = $("<ul />").addClass("cities-list")

                //Генерируем список городов до алфавита
                for(var i = 0; i < response.length; i++) {

                    if (response[i].SORT < 100) {

                        if (prevSort != parseInt(response[i].SORT / 10)) {
                            $citiesList
                                .append(
                                $("<li>")
                                    .addClass("new-line")
                            )
                            prevSort = parseInt(response[i].SORT / 10);
                        }

                        var $a = $("<a />")
                            .prop("href", "#")
                            .data("id", response[i].ID)
                            .data("city", response[i].NAME)
                            .text(response[i].NAME)
                            .addClass("change-city")

                        if (typeof response[i].CURRENT != "undefined")
                            $a.addClass("current")

                        $citiesList.append(
                            $("<li>").append($a)
                        )

                    } else {
                        letters[response[i].NAME.substring(0, 1).toUpperCase()] = true;
                    }
                }

                //Алфавит городов
                var $citiesAlphabet = $("<li />").addClass("alphabet")
                $.each(Object.keys(letters), function(indx, value) {
                    $citiesAlphabet.append(
                        $("<a>")
                            .prop("href", "#")
                            .prop("id", "letter" + value.charCodeAt(0))
                            .text(value)
                    )
                })

                $citiesList
                    .append($citiesAlphabet)

                //Список городов после алфавита
                var $citiesListColumn = $("<ul />").addClass("cities-list column"),
                    firstLetter = "";

                //Генерируем список городов после алфавита
                for(var i = 0; i < response.length; i++) {

                    if (response[i].SORT >= 100) {

                        var cityFirstLetter = response[i].NAME.substring(0, 1).toUpperCase();

                        if (cityFirstLetter != firstLetter) {
                            $citiesListColumn
                                .append(
                                $("<li>")
                                    .addClass("full letter letter" + cityFirstLetter.charCodeAt(0))
                                    .text(cityFirstLetter)
                            )
                            firstLetter = cityFirstLetter
                        }

                        var $a = $("<a>")
                            .prop("href", "#")
                            .data("id", response[i].ID)
                            .data("city", response[i].NAME)
                            .addClass("change-city")

                        if (
                            (i > 0 && response[i - 1].NAME == response[i].NAME) ||
                            (i < response.length - 1 && response[i + 1].NAME == response[i].NAME)
                        ){
                            $a.text(response[i].NAME + ", " + response[i].REGION_NAME)
                        } else {
                            $a.text(response[i].NAME)
                        }

                        if (typeof response[i].CURRENT != "undefined")
                            $a.addClass("current")

                        $citiesListColumn
                            .append(
                            $("<li>")
                                .addClass("letter letter" + cityFirstLetter.charCodeAt(0))
                                .append($a)
                        )

                    }

                }

                //Добавляем список городов
                $(".js-pop-city-select .pop-content")
                    .append($citiesList)
                    .append($citiesListColumn)

            },
            dataType: 'json'
        });

    })

	//Вводить город
	$("input[name=cities-list]").autocomplete({
		source: function(req, responseFn) {
			var re = $.ui.autocomplete.escapeRegex(req.term);
			var matcher = new RegExp( "^" + re, "i" );
			var a = $.grep(cities, function(item, index){
				return matcher.test(item.label);
			});
			responseFn( a );
		},
		select: function( event, ui ) {
			$(".current-city").text(ui.item.city);
			$(".change-city").each(function(){
				if ($(this).data("id") == ui.item.id) {
					$(".change-city").removeClass("current")
					$(this).addClass("current")
				}
			});
			changeCity(ui.item.id)
		}
	});

	//Выбрать город
	$("body").on("click", ".change-city", function() {
		$(".change-city").removeClass("current");
		$(this).addClass("current");
		$(".current-city").text($(this).data("city"));
		$cityId = $(this).data("id");
		changeCity($cityId);

        var date = new Date;
        date.setDate(date.getDate() + 365);
        document.cookie = "BITRIX_SM_cityAccepted="+$cityId+"; expires=" + date.toUTCString();
		return false
	});

	//Меняем город
	function changeCity(id) {
		var url = "/ajax/";
		var datasend = {};
		datasend.action = "change_city";
		datasend.id = id;
		$.ajax({
			url: url,
			type: "POST",
			data: datasend,
			async: true,
			success: function(response) {
                closeCitySelectPopup()
			},
			dataType: 'html'
		});
	}

	//Закрываем модальное окно выбора города
	function closeCitySelectPopup(){
		var $popCloseBtn = $(".js-pop-city-select .js-pop-close")
		if ($popCloseBtn.length == 1) {
			setTimeout(function(){
                $popCloseBtn.trigger("click");
                location.reload()
            }, 400)
		}
	}

	//Выбор буквы
	$("body").on("click", "ul.cities-list li.alphabet a", function(){
		if ($(this).hasClass("select")) {
			$("ul.cities-list li.letter").removeClass("hidden")
			$("ul.cities-list li.alphabet a").removeClass("select")
		} else {
			$("ul.cities-list li.alphabet a").removeClass("select")
			$(this).addClass("select");
			$("ul.cities-list li.letter").addClass("hidden")
			var id = $(this).prop("id")
			$("ul.cities-list li." + id).removeClass("hidden");
		}
		return false;
	})

});

/**
 * Определяет местоположение через
 * yandex maps api
 */
function setGeoCity() {

    ymaps.geolocation.get().then(function (res) {

        var nearest = res.geoObjects.get(0);

        var region   = nearest.properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.AdministrativeAreaName')
        var district = nearest.properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.SubAdministrativeAreaName')
        var city     = nearest.properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName')

        var coord = nearest.geometry.getCoordinates();

        var datasend = {};
        datasend.action   = "change_city_geoloction";
        datasend.region   = region || "";
        datasend.district = district || "";
        datasend.city     = city || "";
        datasend.coord    = coord[0] + "," + coord[1];

        $.ajax({
            url: "/ajax/",
            type: "POST",
            data: datasend,
            async: true,
            success: function(response) {

                //Если удалось определить город перезагружаем страницу
                if (response.result == 1)
                    location.reload()

            },
            dataType: "json"
        });

    }, function (e) {
        //console.error(e);
    });


    /*ymaps.regions.load('RU', {
        lang: 'ru',
        quality: 3
    }).then(function (result) {
        var regions = result.geoObjects; // ссылка на коллекцию GeoObjectCollection
        regionsList = regions.properties._data.geometry.coordinates
        regions.each(function (reg) {
            console.log(reg.properties.get('name'))
        });

        $.each(regions, function(indx, regionName){
            //console.log(regionName);
            var myReverseGeocoder = ymaps.geocode(regionName, {
                kind: 'locality'
                //kind: 'street'
            });
            myReverseGeocoder.then(function (res) {
                var nearest = res.geoObjects.get(0);
                console.log(nearest)
                var region   = nearest.properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.AdministrativeAreaName')
                var district = nearest.properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.SubAdministrativeAreaName')
                var city     = nearest.properties.get('metaDataProperty.GeocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName')
                console.log(region)
                console.log(district)
                console.log(city)
            }, function (e) {
                //console.error(e);
            });
        })
    }, function () {
        alert('No response');
    });*/

}
